export const DEFAULT_MARKET = 'global';
export const DEFAULT_INDUSTRY = 'any';
